import { Component, NgZone } from '@angular/core';
import { Events, IonicPage, MenuController, NavController, Platform } from 'ionic-angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ProofAfterEndPage } from '../proof-after-end/proof-after-end';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { ProofProvider } from '../../providers/proof/proof';
import { AlertProvider } from '../../providers/alert/alert';
import { IdentificationCheckOnWebPage } from '../identification-check-on-web/identification-check-on-web';
import { IdentificationCheckOnAppPage } from '../identification-check-on-app/identification-check-on-app';

declare var YT: any;

@IonicPage()
@Component({
  selector: 'page-proof-video-tutorial',
  templateUrl: 'proof-video-tutorial.html',
})
export class ProofVideoTutorialPage {

  public videoFinished: boolean = false;
  public videoId: string = 'youtubeVideo';
  private player: any;

  constructor(
    private navCtrl: NavController,
    private menu: MenuController,
    private platform: Platform,
    private networkMonitor: NetworkMonitorProvider,
    private proofProvider: ProofProvider,
    private alertProvider: AlertProvider,
    private events: Events,
    private sanitizer: DomSanitizer,
    private zone: NgZone
  ) {}

  // 🔒 BLOQUEIA MENU AO ENTRAR
  ionViewWillEnter() {
    this.menu.enable(false, 'mainMenu');
    this.menu.swipeEnable(false, 'mainMenu');
  }

  // 🔒 BLOQUEIO HARD DE SWIPE (fallback)
  ionViewDidEnter() {
    this.loadYouTubeAPI();

    document.body.addEventListener('touchmove', this.blockSwipe, { passive: false });
  }

  // 🔓 RESTAURA AO SAIR
  ionViewWillLeave() {
    this.menu.enable(true, 'mainMenu');
    this.menu.swipeEnable(true, 'mainMenu');

    document.body.removeEventListener('touchmove', this.blockSwipe);
    // this.events.unsubscribe('doProofUpdate');
  }

  private blockSwipe(event: TouchEvent) {
    event.preventDefault();
  }

  public doContinue(): void {
    let message = this.platform.is('cordova')
      ? 'Para continuar, é necessário ter em mão um documento de identificação oficial com foto recente que possua FOTO + número de CPF (documento único ou dois documentos diferentes). Deseja continuar?'
      : 'Para continuar, é necessário ter em mão um documento de identificação oficial com foto recente que possua <strong>FOTO + número de CPF</strong> (documento único ou dois documentos diferentes).<br /><br />Deseja continuar?';

    this.alertProvider.doConfirm(message, () => {
      if (this.platform.is('cordova')) {
        this.navCtrl.push(IdentificationCheckOnAppPage);
      } else {
        this.navCtrl.push(IdentificationCheckOnWebPage);
      }
    });
  }

  private loadYouTubeAPI() {
    if ((window as any).YT) {
      this.createPlayer();
      return;
    }

    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    (window as any).onYouTubeIframeAPIReady = () => {
      this.createPlayer();
    };
  }

  private createPlayer() {
    if (!YT || !YT.Player) {
      console.error('YT não carregado');
      return;
    }

    this.player = new YT.Player('youtubeVideo', {
      videoId: 'GCrWlBOoPuc',
      playerVars: {
        autoplay: 1,
        rel: 0,
        fs: 0,
        modestbranding: 1
      },
      events: {
        onStateChange: (event: any) => this.onPlayerStateChange(event)
      }
    });
  }

  private onPlayerStateChange(event: any) {
    if (event.data === 0) {
      this.zone.run(() => {
        this.videoFinished = true;
      });
    }
  }
  
  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }  
}


// WEBPACK FOOTER //
// ./src/pages/proof-video-tutorial/proof-video-tutorial.ts